<template>
  <div class="detail-header">
    <el-card shadow="never">
      <div class="detail-header-content">
        <div class="detail-header-title">个人信息</div>
        <el-button style="float: right; padding: 5px 5px"> 返回</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'DetailHeader'
}
</script>

<style lang="scss" scoped>
.detail-header {
  &-content {
    width: 95%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-title{
    margin-left: 20px;
  }
}
</style>
